import { domReady } from 'utilities/dom';
import { utagLinkCheckout } from 'features/tealium';

domReady(() => {

	const trackCheckoutEvent = utagLinkCheckout();

	$('#hdrWrapper').append('<div id="secureMessage">Your information is safe and secure when ordering from us.</div>');

	const agreementContainer = document.querySelector('.agreementContainer');
	const paymentButton = document.querySelector('.agreement a.calloutBtn');

	const readAgreementGAEvents = () => {

		let agreementScrolled = false;
		return () => {

			if (!agreementScrolled) {

				trackCheckoutEvent({
					eventAction: 'Show-More-Delivery-Policy',
					eventCategory: 'Checkout'
				});
				agreementScrolled = true;

			}

		};

	};
	const agreementScrollEvent = readAgreementGAEvents();
	if (agreementContainer) {

		agreementContainer.addEventListener('scroll', () => agreementScrollEvent());

	}

	const agreementGAEvents = () => {

		trackCheckoutEvent({
			eventAction: 'Click-Delivery-Proceed-To-Payment',
			eventCategory: 'Checkout'
		});

	};
	if (paymentButton) {

		paymentButton.addEventListener('click', agreementGAEvents);

	}

});
